const urls = {
  API_ROOT: process.env.REACT_APP_API_ROOT
};

export default urls;